<template>
  <div>
    <v-card dark color="fondoformulario">
      <v-container fluid>
        <v-row no-gutters style="max-height: 600px; overflow:auto">
          <v-col md="12">
            <v-card height="300">
              <v-app-bar elevation="0">
                <v-spacer></v-spacer>
                <v-btn v-if="!readonly" icon @click="seleccionar()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-app-bar>
              <v-container fluid>
                <v-carousel
                  height="180"
                  hide-delimiter-background
                  show-arrows-on-hover
                >
                  <v-carousel-item v-for="doc in listadocumentos" :key="doc.Id">
                    <v-sheet height="180" color="black" tile>
                      <v-row class="fill-height" justify="center">
                        <v-col class="text-center">
                          <h4>{{ doc.Fecha }}</h4>
                          <img
                            v-if="noPDF(doc)"
                            @click="mostrardocumento(doc)"
                            style="cursor: pointer"
                            contain
                            height="100"
                            :src="
                              `${api_url}Archivos/Autorizaciones/${doc.IdImagenes}/${doc.NombreImagen}`
                            "
                          />
                          <v-btn
                            v-if="!noPDF(doc)"
                            height="100"
                            x-large
                            @click="mostrardocumento(doc)"
                          >
                            <v-row>
                              <v-col md="12">
                                PDF
                              </v-col>
                              <v-col md="12">
                                <v-icon x-large>mdi-file-pdf</v-icon>
                              </v-col>
                            </v-row>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-progress-linear
          v-if="porcentaje > 0"
          v-model="porcentaje"
          height="25"
          reactive
        >
          <strong>{{ Math.ceil(porcentaje) }}%</strong>
        </v-progress-linear>
        <v-file-input
          accept="image/*,.pdf"
          id="fileinput"
          :data-idimaten="IdImagenes"
          @change="onFileChanged"
          v-show="false"
        ></v-file-input>

        <v-row justify="center" v-if="dialog">
          <v-dialog v-model="dialog" persistent :max-width="maxwidth">
            <v-card>
              <v-system-bar color="headeryfooter darken-2" dark>
                <v-spacer></v-spacer>
                <v-icon @click="dialog = false">mdi-close</v-icon>
              </v-system-bar>
              <v-card-text class="text-center">
                <v-img
                  v-if="noPDF(docmostrar)"
                  max-height="60vh"
                  style="cursor: pointer"
                  @click="abrirImagen()"
                  :src="
                    `${api_url}Archivos/Autorizaciones/${docmostrar.IdImagenes}/${docmostrar.NombreImagen}`
                  "
                ></v-img>
                <object
                  v-if="!noPDF(docmostrar)"
                  :data="
                    `${api_url}Archivos/Autorizaciones/${docmostrar.IdImagenes}/${docmostrar.NombreImagen}`
                  "
                  type="application/pdf"
                  style="width:90%;height:80vh;"
                >
                  <p>
                    Alternative text - include a link
                    <a
                      :href="
                        `${api_url}Archivos/Autorizaciones/${docmostrar.IdImagenes}/${docmostrar.NombreImagen}`
                      "
                      >to the PDF!</a
                    >
                  </p>
                </object>
                {{ docmostrar.Fecha }}
                <v-btn
                  small
                  v-if="!readonly"
                  color="green darken-1"
                  text
                  @click="confirmar = true"
                >
                  Eliminar
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="confirmar" persistent max-width="330">
      <v-card>
        <v-card-title>Eliminar</v-card-title>
        <v-card-text>Esta seguro que desea eliminar el documento?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="
              eliminar()
              confirmar = false
              dialog = false
            "
            >SI</v-btn
          >
          <v-btn color="red darken-1" text @click="confirmar = false">NO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import authHeader from '@/lib/auth-header'
import axios from 'axios'
import API from '@/lib/API'
import LUM from '@/lib/LUM'
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  props: {
    IdImagenes: Number,
    readonly: Boolean,
  },
  data() {
    return {
      selectedFile: null,
      porcentaje: 0,
      api_url: API.API_URL_ARCHIVOS,
      dialog: false,
      docmostrar: [],
      mostrarTodo: false,
      confirmar: false,
      listadocumentos: null,
    }
  },
  watch: {
    IdImagenes() {
      this.setear()
    },
    // listadocumentos() {
    //   let ret = true;
    //   for (const tipo of this.TiposDocumentosTipoAfiliacion) {
    //     if (
    //       this.listadocumentos.findIndex(
    //         x => x.id_tipo_documentaciones == tipo.id_tipo_documentaciones
    //       ) < 0
    //     ) {
    //       ret = false;
    //     }
    //   }
    //   this.$emit("input", ret);
    // }
  },
  computed: {
    // ...mapState("imagenespracticas", { listadocumentos: "Lista" }),
    maxwidth() {
      let ret = '100%'
      if (this.noPDF(this.docmostrar)) {
        ret = '60vh'
      }
      return ret
    },
  },
  methods: {
    actualizarTipo() {
      this.guardarEntidad(this.docmostrar)
    },
    ...mapMutations('comun', ['mostrar']),
    // ...mapActions("imagenespracticas", ["setPorIdImagenes", "guardarEntidad"]),
    ...mapActions('imagenespracticas', ['set', 'guardarEntidad']),
    async setPorIdImagenes() {
      this.listadocumentos = await API.ImagenesPracticas.traerPorIdImagenes(
        this.IdImagenes
      )
      this.set(this.listadocumentos)
    },
    mostrardocumento(doc) {
      this.tamanoimagen = '60vh'
      this.docmostrar = doc
      this.dialog = true
    },
    seleccionar(id_tipo_documentaciones) {
      // document.getElementById("fileinput").click();
      document
        .querySelector('[data-idimaten="' + this.IdImagenes + '"]')
        .click()
    },
    abrirImagen() {
      window.open(
        `${this.api_url}Archivos/Autorizaciones/${this.docmostrar.IdImagenes}/${this.docmostrar.NombreImagen}`
      )
    },
    fecha(dia) {
      return LUM.datetoDDMMYYYYHHMMSS(dia)
    },
    noPDF(doc) {
      let ret = true
      if (
        doc.NombreImagen.split('.')
          .pop()
          .toUpperCase() == 'PDF'
      ) {
        ret = false
      }
      return ret
    },
    async setear() {
      this.setPorIdImagenes(this.IdImagenes)
    },
    descripcionDocumentacion(id) {
      let tipo = this.Lista.find((x) => x.id_tipo_documentaciones === id)
      if (tipo) {
        return tipo.Descripcion_documentacion
      } else {
      }
      return ''
    },
    onFileChanged(event) {
      this.selectedFile = event
      this.onUpload()
    },
    onUpload() {
      const formData = new FormData()
      formData.append('myFile', this.selectedFile, this.selectedFile.name)
      axios
        .post(
          API.API_URL +
            `FileUploading/UploadFileAutorizacion/${this.IdImagenes}`,
          formData,
          { headers: authHeader() },
          {
            onUploadProgress: (progressEvent) => {
              this.porcentaje =
                (progressEvent.loaded / progressEvent.total) * 100
            },
          }
        )
        .then((resp) => {
          this.mostrar(resp.data)
          this.setPorIdImagenes(this.IdImagenes)
          this.$emit('Upload')
        })
    },
    async eliminar() {
      try {
        ;(await API.FileUploading.eliminarImagen(
          this.IdImagenes,
          this.docmostrar.NombreImagen
          //3
        )) + this.setPorIdImagenes(this.IdImagenes)
      } catch (error) {
        alert(error)
      }
    },
  },
  mounted() {
    this.setear()
  },
}
</script>

<style></style>
